import React from "react";
import { useState } from "react";
import People from "../components/people";

//management
import jessicaCaivano from "../components/headshots/Jessica_Caivano.JPG";
import melKhan from "../components/headshots/Mel_Khan.JPG";
import miaLopez from "../components/headshots/Mia_Lopez.JPG";

//operations
import synaSony from "../components/headshots/Syna_Sony.JPG";
import kainwang from "../components/headshots/Kain_Wang.JPG";
import sophialin from "../components/headshots/SophiaLin.jpg";
import isabellaLee from "../components/headshots/isabellaLee.jpg";
import ryanross from "../components/headshots/Ryan Ross.jpg";
import lexieChen from "../components/headshots/Lexie Chen.jpg";
import ingachen from "../components/headshots/IngaChen.JPG";
import rykynfann from "../components/headshots/Rykyn Fann.jpeg";
import manasareddysanivarapu from "../components/headshots/logo2.png";

//technology
import zahintasnin from "../components/headshots/Zahin_Tasnin.JPG";
import teresachen from "../components/headshots/TeresaChen.jpeg";

//marketing
import graceCarlson from "../components/headshots/Grace Carlson.jpg";
import sherrychen from "../components/headshots/Sherry Chen.jpg";
import suriwang from "../components/headshots/SuriWang.JPG";
import rachelEisenhart from "../components/headshots/Rachel_Eisenhart.jpg";
import chloecho from "../components/headshots/Chloe Cho.jpeg";
import sandraemhenya from "../components/headshots/logo2.png";

//finance
import diMa from "../components/headshots/Di Ma.jpeg";
import xinqilian from "../components/headshots/XinQiLian.JPG";
import lavanyaLehl from "../components/headshots/LavanyaLehl.jpg";
import helenseo from "../components/headshots/Helen Seo.jpeg";
// import sandraemhenya from "../components/headshots/Sandra Emhenya.jpeg";
import jessicazheleznov from "../components/headshots/Jessica Zheleznov.jpeg";
import anastasiaabramova from "../components/headshots/Anastasia Abramova.jpg";
import srinidhipasumarthy from "../components/headshots/Srinidhi Pasumarthy.png";

//events
import emilysavedoff from "../components/headshots/EmilySavedoff.jpg";
import jessicaFrazendeiro from "../components/headshots/Jessica_Fazendeiro.png";
import sophiaJonisch from "../components/headshots/SophiaJonisch.jpg";
import oliviahuang from "../components/headshots/Olivia Huang.jpg";
import briannajustiniano from "../components/headshots/Brianna Justiniano.jpg";
import rodinbehravan from "../components/headshots/Rodin Behravan.png";
import lyladesario from "../components/headshots/Lyla Desario.jpeg";






function Team() {
  const MANAGEMENT = [

    {
      netID: "jmc689",
      name: "Jessica Caivano",
      position: "President",
      image: jessicaCaivano,
      linkedin: "https://www.linkedin.com/in/jess-caivano/"
    },

    {
      netID: "mmk289",
      name: "Mel Khan",
      position: "VP Internal",
      image: melKhan,
      linkedin: "https://www.linkedin.com/in/melanie-khan-7387262ba/"
    
    },

    {
      netID: "mgl89",
      name: "Mia Lopez",
      position: "VP External",
      image: miaLopez,
      linkedin: "https://www.linkedin.com/in/mia-lopez4/"
    
    },

  ];

  const OPS = [
    {
      netID: "ss4352",
      name: "Syna Sony",
      position: "Operations Director",
      image: synaSony,
      linkedin: "https://www.linkedin.com/in/syna-sony-964b152a2/",
    },
    {
      netID: "kcw57",
      name: "Kain Wang",
      position: "Operations Director",
      image: kainwang,
      linkedin: "https://www.linkedin.com/in/kain-wang-4b8525349/"
    
    },
    {
      netID: "sophialin",
      name: "Sophia Lin",
      position: "Operations Associate",
      image: sophialin,
      linkedin: "https://www.linkedin.com/in/sophia-lin-a40421367/"
    },

    {
      netID: "ryanross",
      name: "Ryan Ross",
      position: "Operations Associate/Financial Analyst",
      image: ryanross,
      linkedin: "https://www.linkedin.com/in/ryan-ross-b67621218/"
    },
    {
      netID: "ingachen",
      name: "Inga Chen",
      position: "Operations Associate",
      image: ingachen,
      linkedin: "https://www.linkedin.com/in/inga-chen-175131326?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
    },
    {
      netID: "isabella",
      name: "Isabella Lee",
      position: "Operations Associate",
      image: isabellaLee,
      linkedin: "https://www.linkedin.com/in/isabella-lee928/",
    },
    {
      netID: "lexieChen",
      name: "Lexie Chen",
      position: "Operations Associate",
      image: lexieChen,
      linkedin: "https://www.linkedin.com/in/lexie-chen/"
    },
    {
      netID: "rykynfann",
      name: "Rykyn Fann",
      position: "Operations Associate",
      image: rykynfann,
      linkedin: "https://www.linkedin.com/in/rykyn-fann/"
    },
    {
      netID: "manasareddysanivarapu",
      name: "Manasareddy Sanivarapu",
      position: "Operations Associate",
      image: manasareddysanivarapu,
      linkedin: "https://www.linkedin.com/in/manasareddy-s/"
    }
  ];

  const TECH = [
    {
      netID: "zt276",
      name: "Zahin Tasnin",
      position: "Technology Director",
      image: zahintasnin,
      linkedin: "https://www.linkedin.com/in/zahintasnin/"
    },
    {
      netID: "teresachen",
      name: "Teresa Chen",
      position: "Frontend Software Engineer",
      image: teresachen,
      linkedin: "https://www.linkedin.com/in/teresa-chen0927?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    }
  ];

  const MARKETING = [
    
    {
      netID: "gcc77",
      name: "Grace Carlson",
      position: "Marketing Director",
      image: graceCarlson,
      linkedin: "https://www.linkedin.com/in/grace-carlson-625679328/",
    
    },
    {
      netID: "suriwang",
      name: "Suri Wang",
      position: "Marketing Director",
      image: suriwang,
      linkedin: "https://www.linkedin.com/in/suri-wang-0682972b2?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
    },
    
    {
      netID: "sc3498",
      name: "Sherry Chen",
      position: "Marketing Associate",
      image: sherrychen,
      linkedin: "http://linkedin.com/in/sherry-chen0772",
    },
    {
      netID: "rse53",
      name: "Rachel Eisenhart",
      position: "Photographer",
      image: rachelEisenhart,
      linkedin: "https://www.linkedin.com/in/r-eisenhart/",
    },
    {
      netID: "",
      name: "Helen Seo",
      position: "Financial Analyst",
      image: helenseo,
      linkedin: "https://www.linkedin.com/in/helen-seo-0a4865286/",
    },
    {
      netID: "",
      name: "Chloe Cho",
      position: "Financial Analyst",
      image: chloecho,
      linkedin: "https://www.linkedin.com/company/the-wardrobe-cornell/posts/",
    },
    {
      netID: "",
      name: "Sandra Emhenya",
      position: "Financial Analyst",
      image: sandraemhenya,
      linkedin: "https://www.linkedin.com/in/sandra-o-emhenya/",
    }
  ];

  const FINANCE = [
    
    {
      netID: "dima",
      name: "Di Ma",
      position: "Finance Director",
      image: diMa,
      linkedin: "https://www.linkedin.com/in/didi-ma/",
    },

    {
      netID: "",
      name: "Xin Qi Lian",
      position: "Financial Analyst",
      image: xinqilian,
      linkedin: "https://www.linkedin.com/in/xinqilian/"
    },
    {
      netID: "ryanross",
      name: "Ryan Ross",
      position: "Financial Analyst/Operations Associate",
      image: ryanross,
      linkedin: "https://www.linkedin.com/in/ryan-ross-b67621218/"
    },
    {
      netID: "",
      name: "Lavanya Lehl",
      position: "Financial Analyst",
      image: lavanyaLehl,
      linkedin: "https://www.linkedin.com/in/lavanya-lehl/",
    },
    {
      netID: "",
      name: "Jessi Zeleznov",
      position: "Financial Analyst",
      image: jessicazheleznov,
      linkedin: "https://www.linkedin.com/in/jessica-zheleznov/",
    },
    {
      netID: "",
      name: "Anastasia Abramova",
      position: "Financial Analyst",
      image: anastasiaabramova,
      linkedin: "https://www.linkedin.com/in/anastasia-abramovaa/",
    },
    {
      netID: "",
      name: "Srinidhi Pasumarthy",
      position: "Financial Analyst",
      image: srinidhipasumarthy,
      linkedin: "https://www.linkedin.com/in/srinidhipasumarthy/",
    }
    
  ];
  const EVENTS = [
    {
      netID: "ehs98",
      name: "Emily Savedoff",
      position: "Events Director",
      image: emilysavedoff,
      linkedin: "https://www.linkedin.com/in/emilysavedoff/"
    },
    
    {
      netID:"",
      name: "Jessica Fazendeiro",
      position: "Events Coordinator",
      image: jessicaFrazendeiro,
      linkedin: "https://www.linkedin.com/in/jessica-fazendeiro/",
    },
    {
      netID:"",
      name: "Sophia Jonisch", 
      position: "Events Coordinator",
      image: sophiaJonisch,
      linkedin: "https://www.linkedin.com/in/sophiajonisch/",
    },
    {
      netID: "",
      name: "Olivia Huang",
      position: "Events Coordinator",
      image: oliviahuang,
      linkedin: "https://www.linkedin.com/company/the-wardrobe-cornell/posts/",
    },
    {
      netID: "",
      name: "Brianna Justiniano",
      position: "Events Coordinator",
      image: briannajustiniano,
      linkedin: "https://www.linkedin.com/in/brianna-justiniano-38b089391/",
    },
    {
      netID: "",
      name: "Rodin Behravan",
      position: "Events Coordinator",
      image: rodinbehravan,
      linkedin: "https://www.linkedin.com/in/rodinbehravan/",
    },
    {
      netID: "",
      name: "Lyla Desario",
      position: "Events Coordinator",
      image: lyladesario,
      linkedin: "https://www.linkedin.com/in/lyla-desario-9b67652a4/",
    }
  ];

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="flex flex-col ">
      <div className=" ml-[17%]">
        <div className="w-full ">
          <p className="text-4xl font-bold mt-7">Meet The Team</p>
          <p className="text-1xl mb-3">The faces behind the Wardrobe</p>
        </div>
        <div className="tabs flex space-x-4 flex-wrap">
          <button
            className={
              activeTab === 0
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !mr-4"
                : "tab font-bold px-2 pt-2 !mr-4"
            }
            onClick={() => handleTabClick(0)}
          >
            Management
          </button>
          <button
            className={
              activeTab === 1
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !ml-0 !mr-4"
                : "tab font-bold px-2 pt-2 !ml-0 !mr-4"
            }
            onClick={() => handleTabClick(1)}
          >
            Operations
          </button>
          <button
            className={
              activeTab === 2
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !ml-0 !mr-4"
                : "tab font-bold px-2 pt-2 !ml-0 !mr-4"
            }
            onClick={() => handleTabClick(2)}
          >
            Technology
          </button>
          <button
            className={
              activeTab === 3
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !ml-0 !mr-4"
                : "tab font-bold px-2 pt-2 !ml-0 !mr-4"
            }
            onClick={() => handleTabClick(3)}
          >
            Marketing
          </button>
          <button
            className={
              activeTab === 4
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !ml-0 !mr-4"
                : "tab font-bold px-2 pt-2 !ml-0 !mr-4"
            }
            onClick={() => handleTabClick(4)}
          >
            Finance
          </button>
          <button
            className={
              activeTab === 5
                ? "tab active border-b-2 border-blue-500 font-bold px-2 pt-2 !ml-0 !mr-4"
                : "tab font-bold px-2 pt-2 !ml-0 !mr-4"
            }
            onClick={() => handleTabClick(5)}
          >
            Events
          </button>
        </div>
        <div className="tab-content ">
          {activeTab === 0 && <People items={MANAGEMENT} />}
          {activeTab === 1 && <People items={OPS} />}
          {activeTab === 2 && <People items={TECH} />}
          {activeTab === 3 && <People items={MARKETING} />}
          {activeTab === 4 && <People items={FINANCE} />}
          {activeTab === 5 && <People items={EVENTS} />}
        </div>
      </div>
    </div>
  );
}

export default Team;
